import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCountryDetailByIdQuery } from 'api';

export const useDetails = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data: countryDetails = {} } = useCountryDetailByIdQuery({ id });

  const onModalClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const onModalOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  return {
    isOpen,
    onModalClose,
    onModalOpen,
    countryDetails,
  };
};
